module.exports = __webpack_public_path__ + "img/lock_icon.e9034390.png";